import Link from 'next/link';
import styles from './FooterLinks.module.scss';
import { BasicSpan } from '~/components/common/text/BasicSpan';
import { useRegion } from '~/features/region/hooks/useRegion';
import { useLocale } from '~/hooks/useLocale';
import { useMailto } from '~/hooks/useMailto';
import { useTranslation } from '~/hooks/useTranslation';
import { px } from '~/styles/ts/functions';
import { media } from '~/styles/ts/media';

type Props = {
  className?: string;
};

export const FooterLinks = ({ className = '' }: Props) => {
  const { mailtoText } = useMailto();
  const { t } = useTranslation();
  const { isJapanese } = useLocale();
  const staticLinkPath = isJapanese ? '' : 'en/';
  const { isAJP } = useRegion();

  return (
    <div className={`${styles.container} ${className}`}>
      <Link
        href={
          process.env.NODE_ENV === 'development'
            ? `https://asics-hook.hblab.ai/term.html`
            : `${process.env.NEXT_PUBLIC_BASE_URL}/${staticLinkPath}term.html`
        }
        target="_blank"
      >
        <BasicSpan
          size={26}
          pcSize={26}
          colorStyle="linkGray"
          className={styles['link-text']}
          style={
            media.ua().isPC
              ? {
                  margin: px(0, 16, 24),
                }
              : {}
          }
        >
          {t('terms_ttl')}
        </BasicSpan>
      </Link>
      <Link
        href={
          isJapanese
            ? `https://legal.asics.com/jp-jp/legal/privacy-policy`
            : `https://legal.asics.com/en-jp/legal/privacy-policy`
        }
        target="_blank"
      >
        <BasicSpan
          size={26}
          pcSize={26}
          colorStyle="linkGray"
          className={styles['link-text']}
          style={
            media.ua().isPC
              ? {
                  margin: px(0, 16, 24),
                }
              : {}
          }
        >
          {t('terms_ttl_privacy_policy')}
        </BasicSpan>
      </Link>
      {isAJP && (
        <Link
          href={
            process.env.NODE_ENV === 'development'
              ? `https://asics-hook.hblab.ai/policy.html`
              : `${process.env.NEXT_PUBLIC_BASE_URL}/${staticLinkPath}policy.html`
          }
          target="_blank"
        >
          <BasicSpan
            size={26}
            pcSize={26}
            colorStyle="linkGray"
            className={styles['link-text']}
            style={
              media.ua().isPC
                ? {
                    margin: px(0, 16, 24),
                  }
                : {}
            }
          >
            {t('terms_ttl_privacy_notice')}
          </BasicSpan>
        </Link>
      )}
      {isAJP && (
        <Link
          href={
            isJapanese
              ? 'https://stepnote.asics.com/terms/2023.07.06_ASICS%20STEPNOTE%20%E3%81%8A%E5%AE%A2%E6%A7%98%E6%83%85%E5%A0%B1%E3%81%AE%E5%A4%96%E9%83%A8%E9%80%81%E4%BF%A1%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6%E2%80%97clean.pdf'
              : 'https://stepnote.asics.com/terms/2023.07.06_ASICS%20STEPNOTE%20%E3%81%8A%E5%AE%A2%E6%A7%98%E6%83%85%E5%A0%B1%E3%81%AE%E5%A4%96%E9%83%A8%E9%80%81%E4%BF%A1%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6%E2%80%97clean%20en-US.pdf'
          }
          target="_blank"
          rel="noreferrer"
        >
          <BasicSpan
            size={26}
            pcSize={26}
            colorStyle="linkGray"
            className={styles['link-text']}
            style={
              media.ua().isPC
                ? {
                    margin: px(0, 16, 24),
                  }
                : {}
            }
          >
            {t('menu_ttl_external_transmission')}
          </BasicSpan>
        </Link>
      )}
      <a href="/faq" target="_blank">
        <BasicSpan
          size={26}
          pcSize={26}
          colorStyle="linkGray"
          className={styles['link-text']}
          style={
            media.ua().isPC
              ? {
                  margin: px(0, 16, 24),
                }
              : {}
          }
        >
          {t('menu_ttl_faq')}
        </BasicSpan>
      </a>
      <a href={`mailto:${mailtoText}`} target="_blank" rel="noreferrer">
        <BasicSpan
          size={26}
          pcSize={26}
          colorStyle="linkGray"
          className={styles['link-text']}
          style={
            media.ua().isPC
              ? {
                  margin: px(0, 16, 24),
                }
              : {}
          }
        >
          {t('menu_ttl_contact')}
        </BasicSpan>
      </a>
    </div>
  );
};
